import React from "react"
import * as styles from "./icons.module.scss"

export const CheckedRedesignIcon = () => (
  <svg
    className={styles.checkedGrey}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z"
      fill="#FF3B5B"
    />
    <path
      d="M13.3924 6.83147C13.6695 6.58912 14.0904 6.61701 14.3329 6.89397C14.5752 7.17096 14.5472 7.5919 14.2704 7.8344L8.93737 12.5014C8.92682 12.5106 8.91316 12.5164 8.90221 12.5248C8.88251 12.54 8.86354 12.5552 8.84264 12.5678C8.82516 12.5784 8.80708 12.5872 8.78893 12.5961C8.76921 12.6057 8.74975 12.615 8.72936 12.6225C8.70617 12.6311 8.68284 12.638 8.65905 12.644C8.64216 12.6481 8.62538 12.6519 8.60827 12.6547C8.58162 12.6592 8.55507 12.6613 8.52819 12.6625C8.51252 12.6632 8.49699 12.6639 8.48131 12.6635C8.45635 12.6629 8.43184 12.6601 8.40709 12.6567C8.38909 12.6541 8.37117 12.6519 8.35338 12.6479C8.32405 12.6414 8.2958 12.632 8.26745 12.6215C8.25837 12.6181 8.24906 12.6155 8.2401 12.6117C8.2094 12.5988 8.18003 12.5835 8.15124 12.5658C8.14179 12.56 8.13212 12.5546 8.12292 12.5483C8.09317 12.5279 8.06563 12.5046 8.03893 12.4789C8.03567 12.4758 8.0314 12.4734 8.02819 12.4701L8.00963 12.4516C8.00545 12.4471 8.00004 12.4436 7.99596 12.4389C7.99489 12.4377 7.99409 12.4362 7.99303 12.435L6.02819 10.4701C5.768 10.2098 5.76789 9.78805 6.02819 9.52776C6.28848 9.26746 6.71021 9.26757 6.97057 9.52776L8.52917 11.0863L13.3924 6.83147Z"
      fill="white"
    />
  </svg>
)
